<script lang="ts">
    
    import { onDestroy } from "svelte";
    import type { RealTimeEvent } from "../../global";
    import { PlayersCollection } from "../../Model/PlayersCollection";
    import { eventsChannelsFactory, playersFactory, roomsService } from "../../Services";
    import type { EventsChannel } from "../../Services/EventsChannel";
    import PlayerPill from "../Shared/PlayerPill.svelte";

    export let roomId: string;
    export let playersCount: number = 0;

    const playersCollection = new PlayersCollection();

    let roomEventsChannel: EventsChannel;

    $: bindRoom(roomId);

    onDestroy(() => roomEventsChannel?.destroy());

    async function bindRoom(roomId: string): Promise<void> {
        roomEventsChannel?.destroy();
        playersCollection.clear();
        roomEventsChannel = eventsChannelsFactory.createEventsChannel(`room.${roomId}`);
        roomEventsChannel.on('player_enter', onPlayerEnter);
        roomEventsChannel.on('player_leave', onPlayerLeave);
        roomEventsChannel.on('identity_override', onIdentityOverride);
        const players = await roomsService.getPlayersInRoom(roomId);
        playersCollection.add(...players);
        playersCount = playersCollection.size;
    }

    function onPlayerEnter({ data }: RealTimeEvent): void {
        if (playersCollection.has(data.player.id)) {
            return;
        }
        const player = playersFactory.createPlayerFromDto(data.player);
        playersCollection.add(player);
        playersCount = playersCollection.size;
    }

    function onPlayerLeave({ data }: RealTimeEvent): void {
        playersCollection.delete(data.player.id);
        playersCount = playersCollection.size;
    }

    function onIdentityOverride({ data }: RealTimeEvent): void {
        if (!playersCollection.has(data.player.id)) {
            return;
        }
        const player = playersCollection.get(data.player.id)!;
        player.identityOverride.set(true);
        player.name.set(data.player.name);
        player.pictureId.set(data.player.pictureId);
    }

</script>

{#each [...$playersCollection] as player}
    <slot {player}>
        <PlayerPill {player} />
    </slot>
{/each}
